module.exports = __webpack_public_path__ + "media/Tapping Start a Game Button.4b485812.mp3";